var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import DynamicLinkTab from './DynamicLinkTab';
import Tab from './Tab';
const PanelMenu = (_a) => {
    var { tabs, activedTabKey, onTabToggled = () => { } } = _a, restProps = __rest(_a, ["tabs", "activedTabKey", "onTabToggled"]);
    const defaultExpandedTab = tabs.find(({ key, subs = [] }) => subs.some(({ key: subKey }) => subKey === activedTabKey) && key);
    const [expandedTabKey, setExpandedTabKey] = useState(defaultExpandedTab && defaultExpandedTab.key);
    const handleTabToggled = (newExpandedTabKey, targetRef) => {
        setExpandedTabKey(newExpandedTabKey);
        if (newExpandedTabKey)
            onTabToggled(targetRef);
    };
    return (React.createElement(React.Fragment, null, tabs.map(tab => (React.createElement(DynamicLinkTab, Object.assign({ id: tab.key, TabComponent: Tab, activedTabKey: activedTabKey, expandedTabKey: expandedTabKey, 
        // @ts-ignore
        onTabToggled: handleTabToggled, hoverColor: "SNOW_100", iconHoverColor: "SNOW_100" }, tab, restProps))))));
};
PanelMenu.defaultProps = {
    tabs: [],
    lang: 'zh-hant',
};
export const MenuTab = (_a) => {
    var { tab } = _a, restProps = __rest(_a, ["tab"]);
    return (React.createElement(DynamicLinkTab, Object.assign({ id: tab.key, TabComponent: Tab, hoverColor: "SNOW_100", iconHoverColor: "SNOW_100" }, tab, restProps)));
};
export { default as PanelDropdownMenu } from './DropdownMenu';
export default PanelMenu;
//# sourceMappingURL=index.js.map